import { useLanguage } from '../../i18n/LanguageContext';
import LanguageSwitcher from '../LanguageSwitcher';

/**
 * Spec 085 — the dealer login's showcase panel ("showroom at night"): navy floor, ceiling spotlights and
 * a dealer credit voucher on display (a voucher, never a payment card: legal copy rule, no wallet look). It mirrors the partner login (panel left, form right) so the two portals
 * read as siblings in the Garagat theme rather than the same page. Decorative layers are aria-hidden.
 */
export default function DealerAuthHero() {
  const { t } = useLanguage();
  const points = ['dealer.login.hero.point1', 'dealer.login.hero.point2', 'dealer.login.hero.point3'];

  return (
    <aside className="dealer-hero" aria-label={t('dealer.login.brandLine')}>
      <div className="dealer-hero-lights" aria-hidden="true">
        <span /><span /><span />
      </div>
      <div className="dealer-hero-switch"><LanguageSwitcher variant="inline" /></div>

      <div className="dealer-hero-body">
        <p className="dealer-hero-eyebrow">{t('dealer.login.hero.eyebrow')}</p>
        <h1 className="dealer-hero-title">{t('dealer.login.hero.headline')}</h1>
        <p className="dealer-hero-sub">{t('dealer.login.hero.subline')}</p>

        <ol className="dealer-hero-points">
          {points.map((k, i) => (
            <li key={k} style={{ animationDelay: `${180 + i * 90}ms` }}>
              <span className="dealer-hero-step" aria-hidden="true">{String(i + 1).padStart(2, '0')}</span>
              <span>{t(k)}</span>
            </li>
          ))}
        </ol>
      </div>

      <div className="dealer-hero-stage" aria-hidden="true">
        <div className="dealer-voucher">
          <div className="dealer-voucher-main">
            <span className="dealer-voucher-brand">{t('auth.brand')}</span>
            <span className="dealer-voucher-label">{t('dealer.login.hero.cardLabel')}</span>
            <span className="dealer-voucher-for">{t('dealer.login.hero.cardFor')}</span>
          </div>
          <div className="dealer-voucher-stub">
            <svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
              <circle cx="8" cy="15" r="4" /><path d="M11 12l8-8M16 7l2 2M14 9l2 2" />
            </svg>
            <span className="dealer-voucher-initials">AK</span>
          </div>
        </div>
        <div className="dealer-hero-floor" />
      </div>
    </aside>
  );
}
